import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';
const ItoAmBooked = (props) => {
   const theme = useTheme();
   return (
      <SvgIcon {...props} viewBox="0 0 41 31">
         <g
            id="ITO-Design-System"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
         >
            <g
               id="status/ITOAMpmBooked"
               fill={theme.palette.tableBody.main}
               fillRule="nonzero"
            >
               <path
                  d="M41,0 C41,0 19.4938713,31 19.4938713,31 L15.5,31 C6.48554758,31 0,24.0604136 0,15.5 C0,6.93958638 6.93958638,0 15.5,0 Z M22.6072122,8.6 L12.7128988,19.4057453 L8.7925104,15.1242236 L7.48571429,16.5513975 L12.7128988,22.2600932 L23.9140083,10.0271739 L22.6072122,8.6 Z"
                  id="Oval-2"
               ></path>
            </g>
         </g>
      </SvgIcon>
   );
};

export default ItoAmBooked;
